import { ADD_TO_CARTS_SUCCESS, CLEAR_CART_STATE, FETCH_CARTS_SUCCESS, MERGE_CARTS_SUCCESS, ON_FETCH_SUCCESS, ON_FETCH_FAILURE, MERGE_CARTS_FAILURE, FETCH_CARTS_FAILURE, ADD_TO_CARTS_FAILURE } from '@nike/cart-constants';
var itemIdsReducer = function itemIdsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case MERGE_CARTS_FAILURE:
    case FETCH_CARTS_FAILURE:
    case ADD_TO_CARTS_FAILURE:
    case ON_FETCH_FAILURE:
    case ADD_TO_CARTS_SUCCESS:
    case FETCH_CARTS_SUCCESS:
    case MERGE_CARTS_SUCCESS:
    case ON_FETCH_SUCCESS:
      {
        var _action$payload, _action$payload$data;
        var itemIds = ((action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$data = _action$payload.data) === null || _action$payload$data === void 0 ? void 0 : _action$payload$data.items) || []).map(function (item) {
          return item.id;
        });
        return itemIds;
      }
    case CLEAR_CART_STATE:
      return [];
    default:
      return state;
  }
};
export default itemIdsReducer;